@if (options) {
<div
  #chartContainer
  echarts
  [options]="options"
  (chartInit)="onChartInit($event)"
  class="h-full w-full"
></div>
}
